import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  metalSelectorPill: { 
    textTransform: 'none', 
    borderRadius: 14, 
    padding: '4px 12px', 
    fontSize: 13, 
    fontWeight: 500, 
    lineHeight: 1.2 
  },
  metalSelectorWrap: { 
    display: 'flex', 
    flexWrap: 'wrap', 
    gap: 8 
  }
});

/**
 * Composant pour sélectionner le métal actif
 */
const MetalSelector = ({ metalGroups, selectedMetal, onMetalChange, metauxList }) => {
  const classes = useStyles();

  return (
    <Box className={classes.metalSelectorWrap}>
      {Object.keys(metalGroups).sort((a, b) => a.localeCompare(b)).map(mid => {
        const mo = metauxList.find(m => String(m.id_metal) === String(mid)) || {};
        const gold = String(mid) === '1';
        const label = mo.description || (gold ? 'Or' : 'Métal ' + mid);
        const count = metalGroups[mid].length;
        const active = String(selectedMetal) === String(mid);
        
        return (
          <Button 
            key={mid}
            size="small"
            variant={active ? 'contained' : 'outlined'}
            color={active ? 'primary' : 'default'}
            className={classes.metalSelectorPill}
            onClick={() => onMetalChange(mid)}
          >
            {label} <span style={{ opacity: .65, marginLeft: 6 }}>{count}</span>
          </Button>
        );
      })}
    </Box>
  );
};

MetalSelector.propTypes = {
  metalGroups: PropTypes.object.isRequired,
  selectedMetal: PropTypes.string,
  onMetalChange: PropTypes.func.isRequired,
  metauxList: PropTypes.array.isRequired
};

export default MetalSelector;
